// extracted by mini-css-extract-plugin
module.exports = {"container":"Success_container__27fVY","title":"Success_title__pdsPT","message":"Success_message__12oiZ","button":"Success_button__1I8Zs"};